module.exports = __webpack_public_path__ + "static/media/Macro.42782653.yaml";